import React from "react";
import Hidden from "Components/shared/hidden";
import { OverlayLoader } from "Components/shared/loaders";
import Button from "Components/shared/button";
import Text from "Components/shared/text";
import Select from "Components/shared/select";
import Datalist from "Components/shared/datalist";
import FormControl from "Components/shared/control";
import { InputWithAdornment } from "Components/shared/inputs";
import ProgressBar from "Components/shared/progressbar";
import { MoneyCard } from "Components/shared/cards/MoneyCard";
import { DebitCard } from "Components/shared/cards/DebitCard";

export const Testing = () => {
  const [loading, setLoading] = React.useState(false);

  return (
    <div style={{ maxWidth: "100%" }}>
      <button onClick={() => setLoading(!loading)}>Toggle</button>
      <Hidden mdDown>
        <div>Show on Large Screen only</div>
      </Hidden>
      <Hidden mdUp>
        <div>Show on Small Screen only</div>
      </Hidden>
      <Button loading={loading} label="Let setss" style={{ width: "100%" }}>
        Let set
      </Button>
      <Button variant="empty" color="primary">
        Let set
      </Button>
      <Button variant="outlined" color="primary" fullWidth={true}>
        Let setfff
      </Button>
      <Text color="primary" variant="lg">
        Primary
      </Text>
      <Text color="secondary">Secondary</Text>
      <Datalist options={["One", "Two"]} placeholder="Select" />
      <FormControl
        label="Label"
        id="id"
        name="name"
        error="error"
        fullWidth={true}
      >
        <Select
          options={[
            { value: "2", name: "Two" },
            { value: 3, name: "Three" },
          ]}
          placeholder="Select"
          optionsText={(item) => item.name}
          optionsValue={(item) => item.value}
        />
      </FormControl>
      <FormControl
        id="id"
        name="name"
        fullWidth={true}
        element={<InputWithAdornment placeholder="Your Name" />}
      />
      <InputWithAdornment placeholder="Your Name" left={<div>I Dey</div>} />
      <ProgressBar value={10} />
      <MoneyCard
        background="#21c06b1a"
        symbol="₦"
        currency="NAIRA"
        amount="0.00"
      />
      <DebitCard cardNumber="**** **** **** ****" expiryDate="**/**" />
    </div>
  );
};
